import { Locale } from '@ps-smart-cp/ppfw-client';

const listInquirySearchConditionItemNameConfig = {
  specificSearch: new Map([
    [Locale.ja, '特定の条件で探す'],
    [Locale.en, 'Search with Specific Conditions'],
  ]),

  detailSearch: new Map([
    [Locale.ja, '詳細な条件を指定して探す'],
    [Locale.en, 'Search with Detailed Conditions'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { listInquirySearchConditionItemNameConfig };
